/**
 * 时间公共方法
 * @returns {*}
 */


/**
 * 格式化时间戳 类似PHP的date()
 * @param split
 * @param timeInMs
 * @param timeType
 * @returns {string}
 * @param split 格式 Y.m.d H.i.s |  Y/m/d H/i/s ...(适用各种)
 * @param timeInMs 时间戳
 */
export function getFormatDate(split, timeInMs) {
    var formatDateStr = '';
    var date = new Date();

    date.setTime(timeInMs * 1000);
    for (var i = 0; i < split.length; i++) {
        switch (split[i]) {
            case 'Y':
                formatDateStr += date.getFullYear();
                break;
            case 'm':
                formatDateStr += (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
                break;
            case 'd':
                formatDateStr += (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
                break;
            case 'H':
                formatDateStr += (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours());
                break;
            case 'i':
                formatDateStr += (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes());
                break;
            case 's':
                formatDateStr += (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
                break;
            default :
                formatDateStr += split[i];
                break;
        }
    }
    return formatDateStr;
};

/**
 * 返回当前年月
 * @returns {string}
 */
export function doHandleYearMonth() {
    var myDate = new Date();
    var tYear = myDate.getFullYear();
    var tMonth = myDate.getMonth();

    var m = tMonth + 1;
    if (m.toString().length == 1) {
        m = "0" + m;
    }
    return tYear + '-' + m;
}

/**
 * 返回当前年月
 * @returns {string}
 */
export function doHandleDate() {
    var myDate = new Date();
    var tYear = myDate.getFullYear();
    var tMonth = myDate.getMonth();
    var tDate = myDate.getDate();

    var m = tMonth + 1;
    if (m.toString().length == 1) {
        m = "0" + m;
    }

    var d = tDate;
    if (d.toString().length == 1) {
        d = "0" + d;
    }

    return tYear + '-' + m + '-' + d;
}

/**
 * 返回当前年份
 * @param tYear
 * @returns {number}
 */
export function doHandleYear() {
    var myDate = new Date();
    var tYear = myDate.getFullYear();

    return tYear;
}

/**
 * 返回当前月份
 * @returns {number}
 */
export function doHandleMonth() {
    var myDate = new Date();
    var tMonth = myDate.getMonth();

    var m = tMonth + 1;
    if (m.toString().length == 1) {
        m = "0" + m;
    }
    return m;
}


/**
 * 校验出生日期
 * val: 19950912
 */
export function checkBirth(val) {
    var pattern = /^((19[2-9]\d{1})|(20((0[0-9])|([1-2][0-8]))))\-((0?[1-9])|(1[0-2]))\-((0?[1-9])|([1-2][0-9])|30|31)$/;
    if(pattern.test(val)) {
        var date = new Date(val);
        var month = val.substring(val.indexOf("-")+1,val.lastIndexOf("-"));
        return date && (date.getMonth()+1 == parseInt(month));
    } else {
        var pattern_one = /^((19[2-9]\d{1})|(20((0[0-9])|([1-2][0-8]))))((0?[1-9])|(1[0-2]))((0?[1-9])|([1-2][0-9])|30|31)$/;
        if (pattern_one.test(val)) {
            return true;
        }
    }
    return false;
}
